import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { IssuesIcon } from '../../icons/IssuesIcon';
import { LogoIcon } from '../../icons/LogoIcon';
import { OrgsIcon } from '../../icons/OrgsIcon';
import { UsersIcon } from '../../icons/UsersIcon';
import { Flex } from '../../components/Flex';
import { NavigationItem } from './NavigationItem';
import { ContractsIcon } from '../../icons/ContractsIcon';
import { PackagesIcon } from '../../icons/PackagesIcon';
import { AuditIcon } from '../../icons/AuditIcon';
import { Scrollbar } from '../../components/Scrollbar';
import { ToolsIcon } from '../../icons/ToolsIcon';
import { LicensesIcon } from '../../icons/LicensesIcon';

const MenuItem = styled(Link)`
    ${({ selected }) => selected && css`
        background: rgba(96, 146, 226, .3);
    `}

    min-height: 48px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0px 20px;
    text-decoration: none;

    &:not(:last-child) {
        margin-bottom: 20px;
    }

    & > div:not(:last-child) {
        margin-right: 12px;
    }
`;

const NavigationMenu = ({ selected, collapsed, contractsRead, orgAlias, orgRead, jiraRead, packageRead, auditRead, shcRead, isAdmin }) => {
    const menu = [
        {
            key: isAdmin ? "organisations" : "organisation",
            title: isAdmin ? "organizations" : "organization",
            tooltip: isAdmin ? "organizations" : "organization",
            icon: <OrgsIcon />,
            to: isAdmin ? "/organisations" : "/organisations/" + orgAlias,
            enabled: orgRead
        },
        {
            key: "users",
            icon: <UsersIcon />,
            to: "/users",
            enabled: isAdmin
        },
        {
            key: "issues",
            icon: <IssuesIcon />,
            to: "/issues",
            enabled: jiraRead
        },
        {
            key: "packages",
            icon: <PackagesIcon />,
            to: "/packages",
            enabled: packageRead
        },
        {
            key: "audit",
            icon: <AuditIcon />,
            to: "/audit",
            enabled: auditRead
        },
        {
            key: "contracts",
            icon: <ContractsIcon />,
            to: "/contracts/all",
            enabled: contractsRead
        },
        {
            key: "services",
            icon: <ToolsIcon />,
            to: "/services",
            enabled: isAdmin
        },
        {
            key: "licenses",
            to: "/licenses",
            icon: <LicensesIcon />,
            enabled: isAdmin
        }
    ];

    return(
        <>
            <MenuItem to={`/dashboard`}>
                <LogoIcon collapsed={collapsed} />
            </MenuItem>
            <Flex height="calc(100% - 163px)" margin={{ bottom: "20px" }}>
                <Scrollbar>
                    {menu.map(item => (
                        item.enabled
                            ? <MenuItem key={item.key} to={{ pathname: item.to, state: { from: null }}} selected={item.key === selected}>
                                <NavigationItem item={item} collapsed={collapsed} selected={item.key === selected} />
                            </MenuItem>
                            : null
                    ))}
                </Scrollbar>
            </Flex>
        </>
    )
};

export { NavigationMenu };